/** English defaults for /EditorialBoard — shared by seed and UI. */

export const editorialBoardEn = {
  pageTitle: 'Editorial Board',
  members: {
    m1: {
      name: 'Umarov Abdusalom',
      rank: 'Editor-in-Chief',
      desc: 'Tashkent University of Applied Sciences',
      img: '/Images/Abdusalom.jpg',
      email: 'abdusalom.umarov@utas.edu',
    },
    m2: {
      name: 'Siemens Eduard',
      rank: 'Scientific Editor-in-Chief',
      desc: 'Anhalt University of Applied Sciences, Germany',
      img: '/Images/Eduard.jpg',
      email: 'eduard.siemens@university-tech.edu',
    },
    m3: {
      name: 'Shulakova Kateryna',
      rank: 'Technical Editor',
      desc: 'State University of Intelligent Technologies and Telecommunications, Ukraine',
      img: '/Images/Katerina.jpg',
      email: 'k.s_shulakova@suitt.edu.ua',
    },
    m4: {
      name: 'Elyor Saitov',
      rank: 'Assistant professor',
      desc: 'University of Tashkent for Applied Sciences, Uzbekistan',
      img: '/Images/Elyor.jpg',
      email: 'elyor.saitov@utas.uz',
    },
  },
};
